export var isCarinaIcon = function(icon) {
    return icon.isCarinaIcon;
};
export var isCarinaGlyph = function(icon) {
    return icon.isCarinaGlyph;
};
export var remapIconSize = function(size) {
    switch(size){
        case 's':
            return 'sm';
        case 'l':
        case 'xl':
            return 'lg';
        case 'm':
        default:
            return 'md';
    }
};
